<!-- filter-bar.component.html -->
<div class="row align-items-center justify-content-center">
	@for (filter of filters; track filter.value) {
		<div class="col">
			<button type="button" class="btn text-center waves-effect" [ngClass]="getFilterClasses(filter)" (click)="applyFilter(filter.value)">
				{{ filter.label }}
			</button>
		</div>
	}

	@if (activeFilter) {
		<div class="col-auto">
			<button class="btn btn-sm btn-outline-danger" (click)="applyFilter('')"><i class="ri-close-line"></i> Clear</button>
		</div>
	}
</div>
